// extracted by mini-css-extract-plugin
module.exports = {"container":"IconText_container___FWTg","icon":"IconText_icon__HeB5f","title":"IconText_title__9Xo5d","description_list":"IconText_description_list__Z2HHX"};